import { render, staticRenderFns } from "./StackedColumn.vue?vue&type=template&id=5288d3e7&scoped=true&"
import script from "./StackedColumn.vue?vue&type=script&lang=js&"
export * from "./StackedColumn.vue?vue&type=script&lang=js&"
import style0 from "./StackedColumn.vue?vue&type=style&index=0&id=5288d3e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288d3e7",
  null
  
)

export default component.exports